<spr-page-with-header class="h-full">
	<p-scrollPanel styleClass="absolute top-0 right-0 left-0 bottom-0">
		<div
			[formGroup]="controller.form"
			class="grid grid-cols-1 2xl:grid-cols-2 gap-6 p-6 xl:px-28"
		>
			<spr-settings-information
				formGroupName="information"
			></spr-settings-information>
			<spr-settings-notifications
				formGroupName="notifications"
			></spr-settings-notifications>
			<spr-settings-mfa></spr-settings-mfa>
			<p-card
				*ngIf="controller.canDisassociateCoach$ | async"
				[header]="controller.baseI18 + 'coach' | translate"
				styleClass="h-full"
			>
				<div class="flex flex-col">
					<p-progressSpinner
						*ngIf="controller.isDisassociatingCoach$ | async; else disassociate"
						[style]="{ width: '30px', height: '30px' }"
					></p-progressSpinner>
					<ng-template #disassociate>
						<button
							[label]="controller.baseI18 + 'disassociate.label' | translate"
							(click)="onDisassociateClick()"
							class="w-full"
							pButton
						></button>
					</ng-template>
				</div>
			</p-card>
			<p-card
				[header]="controller.baseI18 + 'help' | translate"
				styleClass="h-full"
			>
				<div class="flex flex-col">
					<button
						[label]="controller.baseI18 + 'tour.label' | translate"
						(click)="onProductTourClick()"
						class="w-full"
						pButton
					></button>
				</div>
			</p-card>
		</div>
	</p-scrollPanel>
	<p-confirmDialog
		[header]="'presentation.app.confirmationDialog.header' | translate"
		icon="pi pi-exclamation-triangle"
	></p-confirmDialog>
</spr-page-with-header>
